import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/D1';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得自行繳費申請條款說明
export function getAgreeTermsD1() {
    return get(`${url}/getAgreeTerms`);
}

// 自行繳費申請條款同意
export function postAgreeD1() {
    return post(`${url}/agree`);
}

export function getInfoD1() {
    return get(`${url}/info`);
}

export function submitD1(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
